import { render } from "./layoutFooter.vue?vue&type=template&id=b5844872&scoped=true"
import script from "./layoutFooter.vue?vue&type=script&lang=js"
export * from "./layoutFooter.vue?vue&type=script&lang=js"

import "./layoutFooter.vue?vue&type=style&index=0&id=b5844872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5844872"]])

export default __exports__